class CartCount extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  async onCartChanged (e) {
    const { state } = e.detail

    if (!state) return

    if (!('push-cart-count' in state?.sections)) return

    this.textContent = this.getCount(state.sections['push-cart-count'])

    if (this.textContent !== '0') {
      this?.externalEls?.cart?.element.setAttribute('aria-active', 'true')
    } else {
      this?.externalEls?.cart?.element.setAttribute('aria-active', 'false')
    }

    const { wishlistSections } = window.BAO.sectionRenderer

    const wishlistSectionHtml = await window.BAO.sectionRenderer.fetch(
      wishlistSections.map(s => s.section),
    )

    window.BAO.sectionRenderer.renderMultiple(
      wishlistSections.map(s =>
        Object.assign({}, s, { html: wishlistSectionHtml[s.section] }),
      ),
    )
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
